<nz-table
	#overviewTable
	[nzData]="data.list"
	[nzPageIndex]="data.pagination.page"
	[nzPageSize]="data.pagination.pageSize"
	[nzTotal]="data.pagination.totalItems ?? 0"
	[nzLoading]="data.loading"
	[nzFrontPagination]="false"
	(nzQueryParams)="onQueryParamsChange.emit($event)"
	nzTableLayout="fixed">
	<thead>
		<tr>
			<th
				nzWidth="80px"
				nzColumnKey="inQuotation"
				claimDirective
				[claims]="[
					{
						claimType: ClaimTypes.Material,
						claimValues: [ClaimValues.Update]
					}
				]">
				{{ 'materials.fields.quotation' | translate }}
			</th>
			<th nzColumnKey="name" [nzSortFn]="true" [nzSortOrder]="'ascend'">
				{{ 'common.name' | translate }}
			</th>
			<th nzColumnKey="description" [nzSortFn]="true">
				{{ 'common.description' | translate }}
			</th>
			<th nzWidth="200px">
				{{ 'materials.fields.priceExclVAT' | translate }}
			</th>
			<th nzWidth="200px">
				{{ 'materials.fields.priceInclVAT' | translate }}
			</th>
			<th
				nzWidth="120px"
				claimDirective
				[claims]="[
					{
						claimType: ClaimTypes.Material,
						claimValues: [ClaimValues.Read, ClaimValues.Delete]
					}
				]"></th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let row of overviewTable.data">
			<td
				nzAlign="center"
				claimDirective
				[claims]="[
					{
						claimType: ClaimTypes.Material,
						claimValues: [ClaimValues.Update]
					}
				]">
				<label
					nz-checkbox
					[nzChecked]="row.inQuotation"
					(nzCheckedChange)="changeQuotation(row.id, !row.inQuotation)"></label>
			</td>
			<td>{{ row.name | truncateText }}</td>
			<td>
				{{ row.description | truncateText : maxDescriptionLength }}
			</td>
			<td nzAlign="right">
				{{ row.priceExclVAT | currency }}
			</td>
			<td nzAlign="right">
				{{ row.priceExclVAT + row.priceExclVAT * row.vatFactor | currency }}
			</td>
			<td
				claimDirective
				[claims]="[
					{
						claimType: ClaimTypes.Material,
						claimValues: [ClaimValues.Read, ClaimValues.Delete]
					}
				]">
				<div class="table-actions">
					<a
						claimDirective
						[claims]="[
							{
								claimType: ClaimTypes.Material,
								claimValues: [ClaimValues.Read]
							}
						]"
						[routerLink]="['/materialen/bewerken', row.id]"
						nz-button
						nzType="text"
						nzShape="circle">
						<i class="fa-regular fa-pen"></i>
					</a>
					<button
						claimDirective
						[claims]="[
							{
								claimType: ClaimTypes.Material,
								claimValues: [ClaimValues.Delete]
							}
						]"
						nz-button
						nzDanger
						nzType="text"
						nzShape="circle"
						nz-popconfirm
						nzOkDanger
						[nzPopconfirmTitle]="'notification.delete' | translate"
						[nzOkText]="'common.delete' | translate"
						[nzCancelText]="'common.cancel' | translate"
						[nzIcon]="templateIconDelete"
						nzPopconfirmPlacement="left"
						(nzOnConfirm)="delete.emit(row.id)">
						<i class="fa-regular fa-trash-can"></i>
					</button>
				</div>
			</td>
		</tr>
	</tbody>
</nz-table>

<ng-template #templateIconDelete>
	<i nz-typography nzType="danger" class="fa-regular fa-trash-can"></i>
</ng-template>
